import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sc-short-link',
  templateUrl: './short-link.component.html',
  styleUrls: ['./short-link.component.scss']
})
export class ShortLinkComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
